module.exports = __webpack_public_path__ + "img/OLD MINER CUT.67c430e7.png";